import { CERCAS_MODULE, CERCAS_VIEW_ANY, CERCAS_MANAGE_ANY } from '@/modules/cercas-virtuais/helpers/permissions'
import { CERCAS_DEV_BYPASS } from '@/modules/cercas-virtuais/helpers/devMode'

const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }
const breadcrumbsApp = { name: 'Aplicativo', pathName: null }
const breadcrumbsCercas = { name: 'Cercas virtuais', pathName: '/v3/cercas-virtuais' }

// Gate de módulo/permissão da rota. Em modo dev (CERCAS_DEV_BYPASS) fica aberto.
const viewGate = CERCAS_DEV_BYPASS ? {} : { requiredModules: [CERCAS_MODULE], requiredUserPermissions: CERCAS_VIEW_ANY, requiredUserPermissionsMatch: 'any' }
const manageGate = CERCAS_DEV_BYPASS
  ? {}
  : { requiredModules: [CERCAS_MODULE], requiredUserPermissions: CERCAS_MANAGE_ANY, requiredUserPermissionsMatch: 'any' }

export default [
  {
    path: '/v3/cercas-virtuais',
    component: () => import('@/views/BaseRoutingComponent.vue'),
    children: [
      {
        path: '',
        name: 'cercas-virtuais',
        component: () => import('@/modules/cercas-virtuais/views/pages/Index.vue'),
        meta: {
          title: 'Cercas virtuais',
          ...viewGate,
          breadcrumbs: [breadcrumbsHome, breadcrumbsApp, { name: 'Cercas virtuais', pathName: null }],
        },
      },
      {
        // Rota estática ANTES de :id para não ser capturada pelo param.
        path: 'nova',
        name: 'cerca-virtual-nova',
        component: () => import('@/modules/cercas-virtuais/views/pages/CercaForm.vue'),
        meta: {
          title: 'Nova cerca virtual',
          ...manageGate,
          breadcrumbs: [breadcrumbsHome, breadcrumbsApp, breadcrumbsCercas, { name: 'Nova cerca virtual', pathName: null }],
        },
      },
      {
        path: ':id',
        name: 'cerca-virtual-detalhe',
        component: () => import('@/modules/cercas-virtuais/views/pages/CercaDetalhe.vue'),
        meta: {
          title: 'Detalhes da cerca virtual',
          ...viewGate,
          breadcrumbs: [breadcrumbsHome, breadcrumbsApp, breadcrumbsCercas, { name: 'Detalhes', pathName: null }],
        },
      },
    ],
  },
]
